module.exports = __webpack_public_path__ + "static/media/Buyer_Image.d8f46e0a.jpg";